import { Component } from 'react'
import {
  Avatar,
  MuiDrawer,
  SidebarMenuProvider,
  MenuItem,
  SidebarMenu,
  Button,
} from '@pinchenterprisesnpm/friday-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons'
import { isMobile } from 'helpers/helperFunctions'
import AuthService from 'services/AuthService'
import { history } from 'helpers/history'
import { connect } from 'react-redux'
import { LoginActions } from 'data/Auth/thunks'
import { ThunkDispatch } from 'redux-thunk'
import { bindActionCreators } from 'redux'
import Auth from 'data/Auth'
import { AppState } from 'store/store'
import { selectAuthUserRole } from 'data/Auth/selectors'
import { isAdminUserByRoleName } from 'helpers/authHelpers'
import { faBars, faUserCircle, faUserFriends } from '@fortawesome/pro-light-svg-icons'
import ROUTES from '@src/routing/adminRoutes'
import Logo from 'img/logo_blackblue_transparent.png'
import UpshifterImg from 'img/Upshifter.svg'
import {
  HeaderWrapper,
  HeaderLogo,
  HeaderUser,
  HeaderLogoImg,
  HeaderUserName,
  HeaderUserAvatar,
  HeaderMenu,
  HeaderMenuItem,
  MobileMenuWrapper,
  MenuImg,
  UserInfoName,
  UserInfoEmail,
  MenuIconWrapper,
  MenuHeader,
  StyledMenu,
  MenuHeaderLeft,
  MenuHeaderRight,
  MenuSubHeader,
} from './style'

type THeaderProps = ILinkDispatchProps & ILinkStateProps

interface THeaderState {
  isOpen: boolean
}

class Header extends Component<THeaderProps, THeaderState> {
  state = {
    isOpen: false,
  }

  userNameRef: HTMLDivElement | null = null

  toggle = () => {
    this.setState((state) => ({ isOpen: !state.isOpen }))
  }

  close = () => {
    this.setState({ isOpen: false })
  }

  mobile = () => {
    const { logout, userRole } = this.props
    const { isOpen } = this.state
    const loggedInUser = AuthService.getLoggedInUser()

    const onSidebarMenuClick = ({ value }: { value: string }) => {
      if (value === ROUTES.LOGOUT) {
        logout()
      } else {
        this.close()
      }
    }

    return (
      <>
        <Button
          onClick={this.toggle}
          type='dark'
          icon={<FontAwesomeIcon icon={faBars} size='lg' />}
        />
        <MuiDrawer placement='left' isOpen={isOpen} closeDrawer={this.close} width='280px'>
          <MenuHeader>
            <MenuHeaderLeft>
              <Button
                onClick={this.close}
                type='dark'
                icon={<FontAwesomeIcon icon={faBars} size='lg' />}
              />
            </MenuHeaderLeft>
            <MenuHeaderRight>Upshift</MenuHeaderRight>
          </MenuHeader>
          <MenuSubHeader>
            <UserInfoName>{loggedInUser?.full_name}</UserInfoName>
            <UserInfoEmail>{loggedInUser?.email}</UserInfoEmail>
          </MenuSubHeader>
          <MobileMenuWrapper>
            <SidebarMenuProvider>
              <SidebarMenu
                selectedItem={location.pathname}
                onClick={onSidebarMenuClick}
                wrapper={StyledMenu}
                isCollapsible={false}
              >
                <MenuItem
                  icon={<MenuImg src={UpshifterImg} role='presentation' alt='upshifters' />}
                  value={ROUTES.ONBOARDER_UPSHIFTERS_LIST}
                  text='Upshifters'
                />
                {isAdminUserByRoleName(userRole) ? (
                  <MenuItem
                    icon={<FontAwesomeIcon icon={faUserFriends} size='lg' />}
                    value={ROUTES.SHIFTS}
                    text='Back to Admin'
                  />
                ) : null}
                <MenuItem
                  icon={<FontAwesomeIcon icon={faUserCircle} size='lg' />}
                  value={ROUTES.LOGOUT}
                  text='Logout'
                  isAtTheBottom
                  isNavLink={false}
                />
              </SidebarMenu>
            </SidebarMenuProvider>
          </MobileMenuWrapper>
        </MuiDrawer>
      </>
    )
  }

  desktop = () => {
    const { logout, userRole } = this.props
    const { isOpen } = this.state
    const loggedInUser = AuthService.getLoggedInUser()
    const icon = isOpen ? faChevronUp : faChevronDown
    return (
      <>
        <HeaderLogo>
          <HeaderLogoImg
            src={Logo}
            alt='logo'
            onClick={() => history.push(ROUTES.ONBOARDER_UPSHIFTERS_LIST)}
          />
        </HeaderLogo>
        <HeaderUser onClick={this.toggle} ref={(node) => (this.userNameRef = node)}>
          <HeaderUserName>
            {loggedInUser?.full_name} <FontAwesomeIcon icon={icon as any} size='xs' />
          </HeaderUserName>
          <HeaderUserAvatar>
            <Avatar
              src='https://i.pinimg.com/originals/51/f6/fb/51f6fb256629fc755b8870c801092942.png'
              size='small'
            />
          </HeaderUserAvatar>
          {isOpen && (
            <HeaderMenu>
              {isAdminUserByRoleName(userRole) ? (
                <HeaderMenuItem onClick={() => history.push(ROUTES.SHIFTS)}>
                  <MenuIconWrapper>
                    <FontAwesomeIcon icon={faUserFriends} size='lg' />
                  </MenuIconWrapper>
                  Back to Admin
                </HeaderMenuItem>
              ) : null}
              <HeaderMenuItem onClick={logout}>
                <MenuIconWrapper>
                  <FontAwesomeIcon icon={faUserCircle} size='lg' />
                </MenuIconWrapper>
                Logout
              </HeaderMenuItem>
            </HeaderMenu>
          )}
        </HeaderUser>
      </>
    )
  }

  closingListener = (e: Event) => {
    if (this.userNameRef) {
      if (!this.userNameRef.contains(e.target as Node)) {
        this.close()
      }
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.closingListener)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closingListener)
  }

  render() {
    return <HeaderWrapper>{isMobile() ? this.mobile() : this.desktop()}</HeaderWrapper>
  }
}

interface ILinkStateProps {
  userRole: string
}

interface ILinkDispatchProps {
  logout: typeof Auth.thunks.logout
}

const mapStateToProps = (state: AppState): ILinkStateProps => ({
  userRole: selectAuthUserRole(state),
})

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, LoginActions>
): ILinkDispatchProps => ({
  logout: bindActionCreators(Auth.thunks.logout, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Header)
